<app-title-bar rootBreadCrumbs="['i18n.core.navigation.reports']" titleText="i18n.domain.reports.payment.title"></app-title-bar>
<div class="row">
  <app-payment-form class="col" [form]="filterForm" (searchDTOChanged)="searchReports()"></app-payment-form>
</div>
@if(filterForm.controls.startDate.value && filterForm.controls.endDate.value) {
<ejs-grid #grid
          class="grid-with-footer"
          width="100%"
          rowHeight="38"
          [allowPaging]="true"
          [pageSettings]="pageSettings"
          [dataSource]="data">
  <e-columns>
    <e-column field="id"
              headerText="{{'i18n.domain.reports.payment.grid.id' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="creationDateTime"
              headerText="{{'i18n.domain.reports.payment.grid.creationDateTime' | translate}}"
              type="date"
              format="dd.MM.yyyy HH:mm:ss"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="clientId"
              headerText="{{'i18n.domain.reports.payment.grid.clientId' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="clientName"
              headerText="{{'i18n.domain.reports.payment.grid.clientName' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="userName"
              headerText="{{'i18n.domain.reports.payment.grid.userName' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="parkingSessionId"
              headerText="{{'i18n.domain.reports.payment.grid.parkingSessionId' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="paymentState"
              headerText="{{'i18n.domain.reports.payment.grid.paymentState' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{formatPaymentState(data.paymentState) | translate}}
      </ng-template>
    </e-column>
    <e-column field="requestedAmount"
              type="number"
              format="N2"
              headerText="{{'i18n.domain.reports.payment.grid.requestAmount' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="requestCurrency"
              headerText="{{'i18n.domain.reports.payment.grid.requestCurrency' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{formatCurrency(data.requestCurrency) | translate}}
      </ng-template>
    </e-column>
    <e-column field="capturedAmount"
              headerText="{{'i18n.domain.reports.payment.grid.capturedAmount' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="transactionBaseFeeInCHF"
              headerText="{{'i18n.domain.reports.payment.grid.transactionBaseFeeInCHF' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="transactionFeeInPercent"
              headerText="{{'i18n.domain.reports.payment.grid.transactionFeeInPercent' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="ancestorPaymentId"
              headerText="{{'i18n.domain.reports.payment.grid.ancestorPaymentId' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
  </e-columns>
</ejs-grid>
<app-reports-footer (saveClicked)="saveReport($event)" [hideFileTypeSelector]="true"></app-reports-footer>
}
